type MaybeResolvedStory<T> = T | string | null | undefined;

export interface CheckedLinks {
	id: number;
	name: string;
	slug: string;
	uuid: string;
	parent_id: number;
	is_checked_folder: boolean;
}

export function getStoriesLoadPaths(folders: CheckedLinks[]): string {
	return folders && folders.length ? folders.map((folder) => folder.slug + '*').join(',') : '';
}

export function isStoryblokStory<T extends object>(value: MaybeResolvedStory<T>): value is T {
	return typeof value === 'object' && value !== null && 'uuid' in value && 'content' in value;
}

export function resolvedStory<T extends object>(value: MaybeResolvedStory<T>): T | undefined {
	return isStoryblokStory(value) ? value : undefined;
}

export function resolvedStories<T extends object>(values: ReadonlyArray<T | string> | null | undefined): T[] {
	return values?.filter(isStoryblokStory) ?? [];
}

export function storyKey(
	story: {uuid?: string; id?: number | string; _uid?: string} | null | undefined,
	fallback: string | number,
): string | number {
	return story?.uuid ?? story?.id ?? story?._uid ?? fallback;
}

/** Nested Storyblok `bloks` are arrays at runtime. */
export function firstBlok<T>(value: readonly T[] | null | undefined): T | undefined {
	return value?.[0];
}
